export default __webpack_public_path__ + "static/media/mission.4d83dc03.png";